import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LoadingComponent } from './loading';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { MiniLoadingComponent } from './mini-loading';
import { Loading3DComponent } from './loading-3d';

@NgModule({
    declarations: [
        LoadingComponent,
        MiniLoadingComponent,
        Loading3DComponent
    ],
    imports: [
        CommonModule,
        SvgIconModule
    ],
    exports: [
        LoadingComponent,
        MiniLoadingComponent,
        Loading3DComponent
    ]
})
export class LoadingComponentModule { }
